// import React, { useContext, useEffect, useState } from 'react';
// import { ShopContext } from '../context/ShopContext';
// import { assets } from '../assets/assets';
// import Title from '../components/Title';
// import ProductItem from '../components/ProductItem';
// import { Helmet } from 'react-helmet-async';

// const Collection = () => {

//   const { products, search, showSearch } = useContext(ShopContext);
//   const [showFilter, setShowFilter] = useState(false);
//   const [filterProducts, setFilterProducts] = useState([]);
//   const [category, setCategory] = useState([]);
//   const [subCategory, setSubCategory] = useState([]);
//   const [sortType, setSortType] = useState('relavent');
//   const [size, setSize] = useState([]);
//   const [priceRange, setPriceRange] = useState([0, 2999]);
//   const [typeFilter, setTypeFilter] = useState([]);
// const [priceFilter, setPriceFilter] = useState('all');

//   const toggleCategory = (e) => {
//     if (category.includes(e.target.value)) {
//       setCategory((prev) => prev.filter((item) => item !== e.target.value));
//     } else {
//       setCategory((prev) => [...prev, e.target.value]);
//     }
//   };

//   const toggleSubCategory = (e) => {
//     if (subCategory.includes(e.target.value)) {
//       setSubCategory((prev) => prev.filter((item) => item !== e.target.value));
//     } else {
//       setSubCategory((prev) => [...prev, e.target.value]);
//     }
//   };

//   const toggleSize = (e) => {
//     if (size.includes(e.target.value)) {
//       setSize((prev) => prev.filter((item) => item !== e.target.value));
//     } else {
//       setSize((prev) => [...prev, e.target.value]);
//     }
//   };

//   const toggleTypeFilter = (e) => {
//     if (typeFilter.includes(e.target.value)) {
//       setTypeFilter((prev) => prev.filter((item) => item !== e.target.value));
//     } else {
//       setTypeFilter((prev) => [...prev, e.target.value]);
//     }
//   };

//   const handlePriceFilter = (e) => {
//     setPriceFilter(e.target.value);
//   };

//   const applyFilter = () => {
//     let productsCopy = products.slice();

//     if (showSearch && search) {
//       productsCopy = productsCopy.filter((item) => item.name.toLowerCase().includes(search.toLowerCase()));
//     }

//     if (category.length > 0) {
//       productsCopy = productsCopy.filter((item) => category.includes(item.category));
//     }

//     if (subCategory.length > 0) {
//       productsCopy = productsCopy.filter((item) => subCategory.includes(item.subCategory));
//     }

//     if (size.length > 0) {
//       productsCopy = productsCopy.filter((item) => size.includes(item.size));
//     }

//     // Filter by type (e.g., Puffed, Both Side Design, etc.)
//     if (typeFilter.length > 0) {
//       productsCopy = productsCopy.filter((item) => typeFilter.includes(item.type));
//     }

//     // Filter by price range
//     if (priceFilter !== 'all') {
//       switch (priceFilter) {
//         case '399-799':
//           productsCopy = productsCopy.filter((item) => item.price >= 399 && item.price <= 799);
//           break;
//         case '799-1099':
//           productsCopy = productsCopy.filter((item) => item.price >= 799 && item.price <= 1099);
//           break;
//         case '1099-1499':
//           productsCopy = productsCopy.filter((item) => item.price >= 1099 && item.price <= 1499);
//           break;
//         case '1499-above':
//           productsCopy = productsCopy.filter((item) => item.price >= 1499);
//           break;
//         default:
//           break;
//       }
//     }

//     // Filter by price range based on the user-selected range
//     productsCopy = productsCopy.filter((item) => item.price >= priceRange[0] && item.price <= priceRange[1]);

//     setFilterProducts(productsCopy);
//   };

//   const sortProduct = () => {
//     let fpCopy = filterProducts.slice();

//     switch (sortType) {
//       case 'low-high':
//         setFilterProducts(fpCopy.sort((a, b) => a.price - b.price));
//         break;

//       case 'high-low':
//         setFilterProducts(fpCopy.sort((a, b) => b.price - a.price));
//         break;

//       default:
//         applyFilter();
//         break;
//     }
//   };

//   useEffect(() => {
//     applyFilter();
//   }, [category, subCategory, size, priceRange, search, showSearch, products, typeFilter, priceFilter]);

//   useEffect(() => {
//     sortProduct();
//   }, [sortType]);

//    // Update dynamic keywords

//    const [keywords, setKeywords] = useState('');

//    const keywordsArray = [
//     ...new Set(products.map((product) => product.name).concat(category, subCategory))
//   ];
//   setKeywords(keywordsArray.join(', '));

//   return (

//     <>
//     {/* Helmet for SEO */}
//      <Helmet>
//      <title>Sweatshirts Collection</title>
//      <meta name="description" content="Explore our exclusive collection of sweatshirts. Available in various styles, sizes, and designs." />
//      <meta name="keywords" content={keywords} />
//    </Helmet>
//     <div className='flex flex-col sm:flex-row gap-1 sm:gap-10 pt-10 border-t'>
//       {/* Filter Options */}
//       <div className='min-w-60'>
//         <p
//           onClick={() => setShowFilter(!showFilter)}
//           className='my-2 text-xl flex items-center cursor-pointer gap-2'
//         >
//           FILTERS
//           <img
//             className={`h-3 sm:hidden ${showFilter ? 'rotate-90' : ''}`}
//             src={assets.dropdown_icon}
//             alt=""
//           />
//         </p>

//         {/* Category Filter */}
//         <div className={`border border-gray-300 pl-5 py-3 mt-6 ${showFilter ? '' : 'hidden'} sm:block`}>
//           <p className='mb-3 text-sm font-medium'>CATEGORIES</p>
//           <div className='flex flex-col gap-2 text-sm font-light text-gray-700'>
//             <p className='flex gap-2'>
//               <input className='w-3' type="checkbox" value={'Oversized T-Shirts'} onChange={toggleCategory} /> Oversized T-Shirts
//             </p>
//             <p className='flex gap-2'>
//               <input className='w-3' type="checkbox" value={'Hoodies'} onChange={toggleCategory} /> Hoodies
//             </p>
//             <p className='flex gap-2'>
//               <input className='w-3' type="checkbox" value={'Sweatshirts'} onChange={toggleCategory} /> Sweatshirts
//             </p>
//           </div>
//         </div>

//         {/* SubCategory Filter */}
//         <div className={`border border-gray-300 pl-5 py-3 my-5 ${showFilter ? '' : 'hidden'} sm:block`}>
//           <p className='mb-3 text-sm font-medium'>TYPE</p>
//           <div className='flex flex-col gap-2 text-sm font-light text-gray-700'>
//             <p className='flex gap-2'>
//               <input className='w-3' type="checkbox" value={'Graphic'} onChange={toggleSubCategory} /> Graphic
//             </p>
//             <p className='flex gap-2'>
//               <input className='w-3' type="checkbox" value={'Bottomwear'} onChange={toggleSubCategory} /> Bottomwear
//             </p>
//             <p className='flex gap-2'>
//               <input className='w-3' type="checkbox" value={'Winterwear'} onChange={toggleSubCategory} /> Winterwear
//             </p>
//           </div>
//         </div>

//         {/* Size Filter */}
//         <div className={`border border-gray-300 pl-5 py-3 my-5 ${showFilter ? '' : 'hidden'} sm:block`}>
//           <p className='mb-3 text-sm font-medium'>SIZE</p>
//           <div className='flex flex-col gap-2 text-sm font-light text-gray-700'>
//             <p className='flex gap-2'>
//               <input className='w-3' type="checkbox" value={'S'} onChange={toggleSize} /> Small (S)
//             </p>
//             <p className='flex gap-2'>
//               <input className='w-3' type="checkbox" value={'M'} onChange={toggleSize} /> Medium (M)
//             </p>
//             <p className='flex gap-2'>
//               <input className='w-3' type="checkbox" value={'L'} onChange={toggleSize} /> Large (L)
//             </p>
//           </div>
//         </div>

//         {/* Price Range Filter */}
// <div className={`border border-gray-300 pl-5 py-3 my-5 ${showFilter ? '' : 'hidden'} sm:block`}>
//   <p className='mb-3 text-sm font-medium'>PRICE RANGE</p>
//   <div className='flex items-center gap-3'>
//     <input
//       type='range'
//       min='0'
//       max='2999'
//       value={priceRange[1]}  // Bind to the max price (right range)
//       onChange={(e) => setPriceRange([0, +e.target.value])}  // Set the start at 0 and update the end value
//       className='w-full mr-2'
//     />
//   </div>
//   <p className='text-sm mt-2'>Price: ₹{priceRange[0]} - ₹{priceRange[1]}</p>
// </div>

// {/* Filter by Type */}
// <div className={`border border-gray-300 pl-5 py-3 my-5 ${showFilter ? '' : 'hidden'} sm:block`}>
//   <p className='mb-3 text-sm font-medium'>FILTER BY TYPE</p>
//   <div className='flex flex-col gap-2 text-sm font-light text-gray-700'>
//     <p className='flex gap-2'>
//       <input className='w-3' type="checkbox" value={'Puffed'} onChange={(e) => toggleTypeFilter(e)} /> Puffed
//     </p>
//     <p className='flex gap-2'>
//       <input className='w-3' type="checkbox" value={'Both Side Design'} onChange={(e) => toggleTypeFilter(e)} /> Both Side Design
//     </p>
//     <p className='flex gap-2'>
//       <input className='w-3' type="checkbox" value={'Single Side Design'} onChange={(e) => toggleTypeFilter(e)} /> Single Side Design
//     </p>
//     <p className='flex gap-2'>
//       <input className='w-3' type="checkbox" value={'Full Side Print'} onChange={(e) => toggleTypeFilter(e)} /> Full Side Print
//     </p>
//   </div>
// </div>

// {/* Price Filter */}
// <div className={`border border-gray-300 pl-5 py-3 my-5 ${showFilter ? '' : 'hidden'} sm:block`}>
//   <p className='mb-3 text-sm font-medium'>PRICE FILTER</p>
//   <div className='flex flex-col gap-2 text-sm font-light text-gray-700'>
//     <p className='flex gap-2'>
//       <input className='w-3' type="radio" name="priceFilter" value="all" onChange={handlePriceFilter} checked={priceFilter === 'all'} /> All
//     </p>
//     <p className='flex gap-2'>
//       <input className='w-3' type="radio" name="priceFilter" value="399-799" onChange={handlePriceFilter} checked={priceFilter === '399-799'} /> ₹399 - ₹799
//     </p>
//     <p className='flex gap-2'>
//       <input className='w-3' type="radio" name="priceFilter" value="799-1099" onChange={handlePriceFilter} checked={priceFilter === '799-1099'} /> ₹799 - ₹1099
//     </p>
//     <p className='flex gap-2'>
//       <input className='w-3' type="radio" name="priceFilter" value="1099-1499" onChange={handlePriceFilter} checked={priceFilter === '1099-1499'} /> ₹1099 - ₹1499
//     </p>
//     <p className='flex gap-2'>
//       <input className='w-3' type="radio" name="priceFilter" value="1499-above" onChange={handlePriceFilter} checked={priceFilter === '1499-above'} /> ₹1499 and Above
//     </p>
//   </div>
// </div>

//       </div>

//       {/* Right Side */}
//       <div className='flex-1'>
//         <div className='flex justify-between text-base sm:text-2xl mb-4'>
//           <Title text1={'ALL'} text2={'COLLECTIONS'} />
//           {/* Product Sort */}
//           <select
//             onChange={(e) => setSortType(e.target.value)}
//             className='border-2 border-gray-300 text-sm px-2'
//           >
//             <option value="relavent">Sort by: Relevant</option>
//             <option value="low-high">Sort by: Low to High</option>
//             <option value="high-low">Sort by: High to Low</option>
//           </select>
//         </div>

//         {/* Map Products */}
//         <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 gap-y-6'>
//           {filterProducts.map((item, index) => (
//             <ProductItem
//               key={index}
//               name={item.name}
//               id={item._id}
//               price={item.price}
//               image={item.image}
//             />
//           ))}
//         </div>
//       </div>
//     </div>
//     </>
//   );
// };

// export default Collection;

import React, { useContext, useEffect, useState } from "react";
import { ShopContext } from "../context/ShopContext";
import { assets } from "../assets/assets";
import Title from "../components/Title";
import ProductItem from "../components/ProductItem";
import axios from "axios";
const Collection = () => {
  
   useEffect(() => {
      const backendUrl = import.meta.env.VITE_BACKEND_URL; // ✅ dynamic URL
      axios.post(`${backendUrl}/api/analytics/visit`, { page: "Collection" })
        .then(res => console.log("Collection visit recorded:", res.data))
        .catch(err => console.error("Analytics error:", err));
    }, []);

  const { products, search, showSearch } = useContext(ShopContext);
  const [showFilter, setShowFilter] = useState(false);
  const [filterProducts, setFilterProducts] = useState([]);
  // const [category, setCategory] = useState([]);
  // const [subCategory, setSubCategory] = useState([]);
  // const [sortType, setSortType] = useState("relavent");
  // const [size, setSize] = useState([]);
  // const [priceRange, setPriceRange] = useState([0, 2999]);
  // const [typeFilter, setTypeFilter] = useState([]);
  // const [priceFilter, setPriceFilter] = useState("all");
  // const [colorFilter, setColorFilter] = useState([]);
  const [category, setCategory] = useState(() => JSON.parse(localStorage.getItem("category")) || []);
  const [subCategory, setSubCategory] = useState(() => JSON.parse(localStorage.getItem("subCategory")) || []);
  const [size, setSize] = useState(() => JSON.parse(localStorage.getItem("size")) || []);
  const [priceRange, setPriceRange] = useState(() => JSON.parse(localStorage.getItem("priceRange")) || [0, 2999]);
  const [typeFilter, setTypeFilter] = useState(() => JSON.parse(localStorage.getItem("typeFilter")) || []);
  const [priceFilter, setPriceFilter] = useState(() => localStorage.getItem("priceFilter") || "all");
  const [colorFilter, setColorFilter] = useState(() => JSON.parse(localStorage.getItem("colorFilter")) || []);
  const [sortType, setSortType] = useState(() => localStorage.getItem("sortType") || "relavent");

  useEffect(() => {
  localStorage.removeItem("category");
  localStorage.removeItem("subCategory");
  localStorage.removeItem("size");
  localStorage.removeItem("priceRange");
  localStorage.removeItem("typeFilter");
  localStorage.removeItem("priceFilter");
  localStorage.removeItem("colorFilter");
  localStorage.removeItem("sortType");

  setCategory([]);
  setSubCategory([]);
  setSize([]);
  setPriceRange([0, 2999]);
  setTypeFilter([]);
  setPriceFilter("all");
  setColorFilter([]);
  setSortType("relavent");
}, []);

  useEffect(() => {
  localStorage.setItem("category", JSON.stringify(category));
  localStorage.setItem("subCategory", JSON.stringify(subCategory));
  localStorage.setItem("size", JSON.stringify(size));
  localStorage.setItem("priceRange", JSON.stringify(priceRange));
  localStorage.setItem("typeFilter", JSON.stringify(typeFilter));
  localStorage.setItem("priceFilter", priceFilter);
  localStorage.setItem("colorFilter", JSON.stringify(colorFilter));
  localStorage.setItem("sortType", sortType);
}, [category, subCategory, size, priceRange, typeFilter, priceFilter, colorFilter, sortType]);


 const clearAllFilters = () => {
  [
    "category",
    "subCategory",
    "size",
    "priceRange",
    "typeFilter",
    "priceFilter",
    "colorFilter",
    "sortType"
  ].forEach(key => localStorage.removeItem(key));

  window.location.reload();
};
  const toggleCategory = (e) => {
    if (category.includes(e.target.value)) {
      setCategory((prev) => prev.filter((item) => item !== e.target.value));
    } else {
      setCategory((prev) => [...prev, e.target.value]);
    }
  };

  const toggleSubCategory = (e) => {
    if (subCategory.includes(e.target.value)) {
      setSubCategory((prev) => prev.filter((item) => item !== e.target.value));
    } else {
      setSubCategory((prev) => [...prev, e.target.value]);
    }
  };

  const toggleSize = (e) => {
    if (size.includes(e.target.value)) {
      setSize((prev) => prev.filter((item) => item !== e.target.value));
    } else {
      setSize((prev) => [...prev, e.target.value]);
    }
  };

  const toggleTypeFilter = (e) => {
    if (typeFilter.includes(e.target.value)) {
      setTypeFilter((prev) => prev.filter((item) => item !== e.target.value));
    } else {
      setTypeFilter((prev) => [...prev, e.target.value]);
    }
  };

  const handlePriceFilter = (e) => {
    setPriceFilter(e.target.value);
  };

  const toggleColorFilter = (e) => {
    if (colorFilter.includes(e.target.value)) {
      setColorFilter((prev) => prev.filter((item) => item !== e.target.value));
    } else {
      setColorFilter((prev) => [...prev, e.target.value]);
    }
  };

  const applyFilter = () => {
    let productsCopy = products.slice();

    if (showSearch && search) {
      productsCopy = productsCopy.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (category.length > 0) {
      productsCopy = productsCopy.filter((item) =>
        category.includes(item.category)
      );
    }

    if (subCategory.length > 0) {
      productsCopy = productsCopy.filter((item) =>
        subCategory.includes(item.subCategory)
      );
    }

    // if (size.length > 0) {
    //   productsCopy = productsCopy.filter(
    //     (item) =>
    //       item.size &&
    //       Array.isArray(item.size) &&
    //       item.size.some((s) => size.includes(s))
    //   );
    // }
    if (size.length > 0) {
  productsCopy = productsCopy.filter((item) => {
    if (!item.size && !item.sizes) return false;

    // Case 1: item.size is an array
    if (Array.isArray(item.size)) {
      return item.size.some((s) => size.includes(s.toUpperCase()));
    }

    // Case 2: item.size is a single string
    if (typeof item.size === "string") {
      return size.includes(item.size.toUpperCase());
    }

    // Case 3: item.sizes exists
    if (Array.isArray(item.sizes)) {
      return item.sizes.some((s) => size.includes(s.toUpperCase()));
    }

    return false;
  });
}

    if (colorFilter.length > 0) {
      productsCopy = productsCopy.filter((item) =>
        item.colors.some((color) => colorFilter.includes(color))
      );
    }
    // Filter by price range
    if (priceFilter !== "all") {
      switch (priceFilter) {
        case "399-799":
          productsCopy = productsCopy.filter(
            (item) => item.price >= 399 && item.price <= 799
          );
          break;
        case "799-1099":
          productsCopy = productsCopy.filter(
            (item) => item.price >= 799 && item.price <= 1099
          );
          break;
        case "1099-1499":
          productsCopy = productsCopy.filter(
            (item) => item.price >= 1099 && item.price <= 1499
          );
          break;
        case "1499-above":
          productsCopy = productsCopy.filter((item) => item.price >= 1499);
          break;
        default:
          break;
      }
    }

    // Filter by price range based on the user-selected range
    productsCopy = productsCopy.filter(
      (item) => item.price >= priceRange[0] && item.price <= priceRange[1]
    );

    setFilterProducts(productsCopy);
  };

  const sortProduct = () => {
    let fpCopy = filterProducts.slice();

    switch (sortType) {
      case "low-high":
        setFilterProducts(fpCopy.sort((a, b) => a.price - b.price));
        break;

      case "high-low":
        setFilterProducts(fpCopy.sort((a, b) => b.price - a.price));
        break;

      default:
        applyFilter();
        break;
    }
  };

  useEffect(() => {
    applyFilter();
  }, [
    category,
    subCategory,
    size,
    priceRange,
    search,
    showSearch,
    products,
    typeFilter,
    priceFilter,
    colorFilter
  ]);

  useEffect(() => {
    sortProduct();
  }, [sortType]);

  return (
    <div className="flex flex-col sm:flex-row gap-1 sm:gap-10 pt-10 border-t">
      {/* Filter Options */}
      <div className="min-w-60">
        <p
          onClick={() => setShowFilter(!showFilter)}
          className="my-2  flex items-center cursor-pointer gap-2  text-xs lg:text-xl"
        >
          FILTERS
          <img
            className={`h-3 sm:hidden ${showFilter ? "rotate-90" : ""}`}
            src={assets.dropdown_icon}
            alt=""
          />
        </p>

        {/* Category Filter */}
        <div
          className={`border border-gray-300 pl-5 py-3 mt-6 ${
            showFilter ? "" : "hidden"
          } sm:block`}
        >
          <p className="mb-3 text-sm font-medium">CATEGORIES</p>
          <div className="flex flex-col gap-2 text-sm font-light text-gray-700">
            <p className="flex gap-2 font-semibold text-[#FF4902]">
              <input
                className="w-3 "
                type="checkbox"
                value={"Oversized T-Shirts"}
                onChange={toggleCategory}
                checked={category.includes("Oversized T-Shirts")}
              />{" "}
             Oversized T-Shirts 
            </p>
            <p className="flex gap-2 font-semibold text-[#FF4902]">
              <input
                className="w-3"
                type="checkbox"
                value={"Hoodies"}
                onChange={toggleCategory}
                 checked={category.includes("Hoodies")}
              />{" "}
              Hoodies
            </p>
            <p className="flex gap-2 font-semibold text-[#FF4902]">
              <input
                className="w-3"
                type="checkbox"
                value={"Sweatshirts"}
                onChange={toggleCategory}
                 checked={category.includes("Sweatshirts")}
              />{" "}
              Sweatshirts
            </p>
          </div>
        </div>

        {/* SubCategory Filter */}
        <div
          className={`border border-gray-300 pl-5 py-3 my-5 ${
            showFilter ? "" : "hidden"
          } sm:block`}
        >
          <p className="mb-3 text-sm font-medium">TYPE</p>
          <div className="flex flex-col gap-2 text-sm font-light text-gray-700">
            <p className="flex gap-2">
              <input
                className="w-3"
                type="checkbox"
                value={"M"}
                onChange={toggleSubCategory}
                 checked={subCategory.includes("M")}
              />{" "}
              Men
            </p>
            <p className="flex gap-2">
              <input
                className="w-3"
                type="checkbox"
                value={"F"}
                onChange={toggleSubCategory}
                 checked={subCategory.includes("F")}
              />{" "}
              Women
            </p>
            <p className="flex gap-2">
              <input
                className="w-3"
                type="checkbox"
                value={"K"}
                onChange={toggleSubCategory}
                checked={subCategory.includes("K")}
              />{" "}
              Kids
            </p>
          </div>
        </div>

        {/* Size Filter */}
        <div
          className={`border border-gray-300 pl-5 py-3 my-5 ${
            showFilter ? "" : "hidden"
          } sm:block`}
        >
          <p className="mb-3 text-sm font-medium">SIZE</p>
          <div className="flex flex-col gap-2 text-sm font-light text-gray-700">
            <p className="flex gap-2">
              <input
                className="w-3"
                type="checkbox"
                value={"S"}
                onChange={toggleSize}
                 checked={size.includes("S")}
              />{" "}
              Small (S)
            </p>
            <p className="flex gap-2">
              <input
                className="w-3"
                type="checkbox"
                value={"M"}
                onChange={toggleSize}
                checked={size.includes("M")}
              />{" "}
              Medium (M)
            </p>
            <p className="flex gap-2">
              <input
                className="w-3"
                type="checkbox"
                value={"L"}
                onChange={toggleSize}
                checked={size.includes("L")}
              />{" "}
              Large (L)
            </p>
            <p className="flex gap-2">
              <input
                className="w-3"
                type="checkbox"
                value={"XL"}
                onChange={toggleSize}
                checked={size.includes("XL")}
              />{" "}
              Extra Large (XL)
            </p>
            <p className="flex gap-2">
              <input
                className="w-3"
                type="checkbox"
                value={"XXL"}
                onChange={toggleSize}
                checked={size.includes("XXL")}
              />{" "}
              Extra Extra Large (XXL)
            </p>
          </div>
        </div>

        {/* Color Filter */}
        <div
          className={`border border-gray-300 pl-5 py-3 my-5 ${
            showFilter ? "" : "hidden"
          } sm:block`}
        >
          <p className="mb-3 text-sm font-medium">FILTER BY COLOR</p>
          <div className="flex flex-col gap-2 text-sm font-light text-gray-700">
            {[
              { code: "#F6F6F6", name: "Bone White" },
              { code: "#151515", name: "Magma Black" },
         
              { code: "#C5DDAC", name: "Moss Green" },
              { code: "#2C2CBD", name: "Midnight Blue" },
              { code: "#745539", name: "Amber Crust" },
              { code: "#FAEEB2", name: "Ivory Ember" },
          
            ].map((color, index) => (
              <p key={index} className="flex gap-2 items-center">
                <input
                  className="w-3"
                  type="checkbox"
                  value={color.code}
                  onChange={toggleColorFilter}
                  checked={colorFilter.includes(color.code)}
                />
                <span
                  className="w-4 h-4 rounded-full border border-gray-400"
                  style={{ backgroundColor: color.code }}
                ></span>
                {color.name}
              </p>
            ))}
          </div>
        </div>

        {/* Price Range Filter */}
        <div
          className={`border border-gray-300 pl-5 py-3 my-5 ${
            showFilter ? "" : "hidden"
          } sm:block`}
        >
          <p className="mb-3 text-sm font-medium">PRICE RANGE</p>
          <div className="flex items-center gap-3">
            <input
              type="range"
              min="0"
              max="2999"
              value={priceRange[1]} // Bind to the max price (right range)
              onChange={(e) => setPriceRange([0, +e.target.value])} // Set the start at 0 and update the end value
               checked={priceFilter === "0-2999"}
              className="w-full mr-2"
            />
          </div>
          <p className="text-sm mt-2">
            Price: ₹{priceRange[0]} - ₹{priceRange[1]}
          </p>
        </div>

        {/* Filter by Type */}
        {/* <div
          className={`border border-gray-300 pl-5 py-3 my-5 ${
            showFilter ? "" : "hidden"
          } sm:block`}
        >
          <p className="mb-3 text-sm font-medium">FILTER BY TYPE</p>
          <div className="flex flex-col gap-2 text-sm font-light text-gray-700">
            <p className="flex gap-2">
              <input
                className="w-3"
                type="checkbox"
                value={"Puffed"}
                onChange={(e) => toggleTypeFilter(e)}
              />{" "}
              Puffed
            </p>
            <p className="flex gap-2">
              <input
                className="w-3"
                type="checkbox"
                value={"Both Side Design"}
                onChange={(e) => toggleTypeFilter(e)}
              />{" "}
              Both Side Design
            </p>
            <p className="flex gap-2">
              <input
                className="w-3"
                type="checkbox"
                value={"Single Side Design"}
                onChange={(e) => toggleTypeFilter(e)}
              />{" "}
              Single Side Design
            </p>
            <p className="flex gap-2">
              <input
                className="w-3"
                type="checkbox"
                value={"Full Side Print"}
                onChange={(e) => toggleTypeFilter(e)}
              />{" "}
              Full Side Print
            </p>
          </div>
        </div> */}

        {/* Price Filter */}
        <div
          className={`border border-gray-300 pl-5 py-3 my-5 ${
            showFilter ? "" : "hidden"
          } sm:block`}
        >
          <p className="mb-3 text-sm font-medium">PRICE FILTER</p>
          <div className="flex flex-col gap-2 text-sm font-light text-gray-700">
            <p className="flex gap-2">
              <input
                className="w-3"
                type="radio"
                name="priceFilter"
                value="all"
                onChange={handlePriceFilter}
                checked={priceFilter === "all"}
              />{" "}
              All
            </p>
            <p className="flex gap-2">
              <input
                className="w-3"
                type="radio"
                name="priceFilter"
                value="399-799"
                onChange={handlePriceFilter}
                checked={priceFilter === "399-799"}
              />{" "}
              ₹399 - ₹799
            </p>
            <p className="flex gap-2">
              <input
                className="w-3"
                type="radio"
                name="priceFilter"
                value="799-1099"
                onChange={handlePriceFilter}
                checked={priceFilter === "799-1099"}
              />{" "}
              ₹799 - ₹1099
            </p>
            <p className="flex gap-2">
              <input
                className="w-3"
                type="radio"
                name="priceFilter"
                value="1099-1499"
                onChange={handlePriceFilter}
                checked={priceFilter === "1099-1499"}
              />{" "}
              ₹1099 - ₹1499
            </p>
            <p className="flex gap-2">
              <input
                className="w-3"
                type="radio"
                name="priceFilter"
                value="1499-above"
                onChange={handlePriceFilter}
                checked={priceFilter === "1499-above"}
              />{" "}
              ₹1499 and Above
            </p>
          </div>
        </div>
      </div>

      {/* Right Side */}
      <div className="flex-1">
        <div className="flex justify-between text-base sm:text-2xl mb-4">
          <Title text1={"ALL"} text2={"COLLECTIONS"} />
          {/* Product Sort */}
          <select
            onChange={(e) => setSortType(e.target.value)}
            className="border-2 border-gray-300 text-sm px-2"
          >
            <option value="relavent">Sort by: Relevant</option>
            <option value="low-high">Sort by: Low to High</option>
            <option value="high-low">Sort by: High to Low</option>
          </select>
        </div>

        {/* Map Products */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 gap-y-6">
          {filterProducts
            .sort((a, b) => {
              const rankA = a.rank ?? Infinity; // if no rank, treat as very low priority
              const rankB = b.rank ?? Infinity;
              return rankA - rankB;
            })
            .map((item, index) => (
              <ProductItem
                key={index}
                id={item._id}
                image={item.image}
                name={item.name}
                price={item.price}
                op={item.originalPrice}
                importance="high"
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default Collection;

// { code: "red", name: "Red" },
// { code: "blue", name: "Blue" },
// { code: "green", name: "Green" },
// { code: "orange", name: "Orange" },
// { code: "yellow", name: "Yellow" },

// if (size.length > 0) {
//   productsCopy = productsCopy.filter((item) => size.includes(item.size));
// }

// Filter by type (e.g., Puffed, Both Side Design, etc.)
// if (typeFilter.length > 0) {
//   productsCopy = productsCopy.filter((item) => typeFilter.includes(item.type));
// }

// Filter by color
//  if (colorFilter.length > 0) {
//   productsCopy = productsCopy.filter((item) => colorFilter.includes(item.colors));
// }
